export const ClientActionEventIdentities = {
    UserRequestedBooking: {
        eventType: "Click",
        eventObject: "RequestBookingButton",
    },
    UserDidInstantBooking: {
        eventType: "Click",
        eventObject: "BookingInstantButton",
    },
    UserViewedPage: {
        eventType: "View",
        eventObject: "Page",
    },
    UserSignedUpWithEmail: {
        eventType: "Click",
        eventObject: "SignedUpWithEmailButton",
    },
    UserSignedUpWithFacebook: {
        eventType: "Click",
        eventObject: "SignedUpWithFacebookButton",
    },
    UserSignedUpWithApple: {
        eventType: "Click",
        eventObject: "SignedUpWithAppleButton",
    },
    UserSignedUpWithGoogle: {
        eventType: "Click",
        eventObject: "SignedUpWithGoogleButton",
    },
    UserSignedInWithEmail: {
        eventType: "Click",
        eventObject: "SignedInWithEmailButton",
    },
    UserSignedInWithFacebook: {
        eventType: "Click",
        eventObject: "SignedInWithFacebookButton",
    },
    UserSignedInWithApple: {
        eventType: "Click",
        eventObject: "SignedInWithAppleButton",
    },
    UserSignedInWithGoogle: {
        eventType: "Click",
        eventObject: "SignedInWithGoogleButton",
    },
    UserFavouredBoat: {
        eventType: "Click",
        eventObject: "FavourBoatButton",
    },
};
